<script>
import { Line } from 'vue-chartjs'
export default {
    name: 'revenuesPerHour',
    extends: Line,
    props: [
        'options',
        'chartData'
    ],
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
}
</script>
<style scoped>

</style>